/*
 * ping-sample-web-react-todo-oidc
 *
 * constants.js
 *
 * Copyright (c) 2026 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export const API_URL = process.env.API_URL;
// Yes, the debugger boolean is intentionally reversed
export const DEBUGGER = process.env.DEBUGGER_OFF === 'false';
export const APP_URL = process.env.APP_URL;
export const WEB_OAUTH_CLIENT = process.env.WEB_OAUTH_CLIENT;
export const REALM_PATH = process.env.REALM_PATH;
export const SCOPE = process.env.SCOPE;
export const WELLKNOWN_URL = process.env.WELLKNOWN_URL;
export const INIT_PROTECT = process.env.INIT_PROTECT;
export const PINGONE_ENV_ID = process.env.PINGONE_ENV_ID;

const appBaseUrl = APP_URL || window.location.origin;

export const CONFIG = {
  clientId: WEB_OAUTH_CLIENT,
  redirectUri: `${appBaseUrl}/callback.html`,
  scope: SCOPE,
  serverConfig: {
    wellknown: WELLKNOWN_URL,
  },
  realmPath: REALM_PATH,
};
